import reactSlugify from "react-slugify"

export const convertTimestamp = (timestamp) => {
    const date = new Date(timestamp);
    return (date.getMonth() + 1) + "/" + (date.getDate()<10?"0"+date.getDate():date.getDate())+ "/" + date.getFullYear()
}

export const slugify = (input) => {
    return reactSlugify(input.replace(/^\/|\/$/g, '')).toLowerCase()
}